import { defineMessages } from 'react-intl';

export const a2aPolicyAlertMessages = defineMessages({
  blockedTitle: {
    id: 'oauth.a2a.policyAlert.blocked.title',
    defaultMessage: 'Access to this domain is restricted',
    description: 'Error title when admin policy blocks the redirect URL domain',
  },
  blockedBody: {
    id: 'oauth.a2a.policyAlert.blocked.body',
    defaultMessage:
      'Your admin has blocked this domain \"{redirectUrl}\" in your organization’s settings. To request access, contact your organization admin or <allowlistLink>find out about domain restrictions</allowlistLink>.',
    description:
      'Error body when admin policy blocks the redirect, with embedded link to the admin allowlist documentation; {redirectUrl} is interpolated',
  },
  errorTitle: {
    id: 'oauth.a2a.policyAlert.error.title',
    defaultMessage: "We couldn't verify permissions for this site",
    description: 'Error title when domain check fails due to an infra error',
  },
  errorBody: {
    id: 'oauth.a2a.policyAlert.error.body',
    defaultMessage:
      'We\u2019re having trouble showing permissions right now. You can try refreshing the page or <supportLink>contact support</supportLink>.',
    description:
      'Error body when domain check fails due to an infra error, with embedded link to the Atlassian support page',
  },
  siteFallback: {
    id: 'oauth.a2a.policyAlert.siteFallback',
    defaultMessage: 'your Atlassian site',
    description: 'Fallback label used when the site name is not available',
  },
  a2aRestrictedTitle: {
    id: 'oauth.a2a.policyAlert.a2aRestricted.title',
    defaultMessage: 'Access to A2A is restricted',
    description: 'Error title when A2A is restricted by the organization admin',
  },
  clientDisabledTitle: {
    id: 'oauth.a2a.policyAlert.clientDisabled.title',
    defaultMessage: '{appName} is unavailable for this site',
    description:
      'Error title when an admin has disabled the app, or its system account, for the organization that owns the selected site; {appName} is the app display name',
  },
  clientDisabledBody: {
    id: 'oauth.a2a.policyAlert.clientDisabled.body',
    defaultMessage:
      'An admin has disabled {appName} for "{siteLabel}". Select a different site, or contact the admin of that site to restore access.',
    description:
      'Error body when an admin has disabled the app, or its system account, for the organization that owns the selected site; {appName} is the app display name, {siteLabel} is the selected site',
  },
  appFallback: {
    id: 'oauth.a2a.policyAlert.appFallback',
    defaultMessage: 'This app',
    description:
      'Fallback label used in place of the app name when it is not available',
  },
  a2aRestrictedBody: {
    id: 'oauth.a2a.policyAlert.a2aRestricted.body',
    defaultMessage:
      'Your admin has blocked A2A usage in your organization\u2019s settings. To request access, contact your organization admin or <a2aRestrictedLink>find out about A2A restrictions</a2aRestrictedLink>.',
    description:
      'Error body when A2A is restricted by the organization admin, with embedded link to documentation about A2A restrictions',
  },
});
